import { StaticImageData } from "next/image";

// using a type guard
export function isStaticImageData(image: string | StaticImageData | null): image is StaticImageData
{
    if (image === null) return false;
    
    return (image as StaticImageData).src !== undefined;
}